import React, { FC } from 'react'
import styles from './styles.module.scss'

type LayoutProps = {
  leftContent?: JSX.Element | string | null
  children?: JSX.Element | string | null
}

const LayoutContent: FC<LayoutProps> = ({ leftContent, children }) => {
  return (
    <div className={styles.page_layout}>
      <div className={styles.page_container}>
        <div className={`${styles.side} ${styles.left_side}`}>
          <div className={styles.left_content}>{leftContent}</div>
        </div>
        <div className={`${styles.side} ${styles.right_side}`}>
          <div className={styles.right_content}>{children}</div>
        </div>
      </div>
    </div>
  )
}

export default LayoutContent
